import { Component, Mixins, Emit, Watch } from 'vue-property-decorator';
import ViewPage from '@/mixins/Views';
import { Route } from 'vue-router';
// @ is an alias to /src
import store from '@/store';
import {
  PAGES_SLICK_ANCHOR_DELAY_MS,
  scrollElementIntoViewBelowFixedHeader,
} from '@/lib/scrollAnchor';
import $ from 'jquery';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css'; // 追加
import 'slick-carousel/slick/slick-theme.css'; // 追加

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate',
  'beforeDestroy',
]);

@Component
export default class Pages extends Mixins(ViewPage) {
  private name = 'pages';
  private slug: string|null = null;
  get entryData(): HTMLElement {
    return this.$store.getters['pages/data'][0].content;
  }
  get loadedPost(): boolean {
    return store.getters['pages/loaded'];
  }
  get statusCode(): number {
    return store.getters['pages/statusCode'];
  }
  get lang(): string {
    return this.$store.getters['auth/lang'];
  }

  @Watch('loadedPost', { immediate: true })
  private onLoadedPostChange(loadedPost: boolean) {
    if (!loadedPost || this.statusCode !== 200) {
      return;
    }
    this.$nextTick(() => {
      this.scheduleScrollAfterSlickLayout();
    });
  }

  /**
   * slick-carousel が .slick() されると高さ・幅が変わるため、
   * その後にアンカーへスクロールしないと位置がずれる。
   */
  private scheduleScrollAfterSlickLayout() {
    const run = () => this.runScrollAfterContentReady(0);
    // v-html と子の mounted が終わってから判定
    this.$nextTick(() => {
      const hasSlick = document.querySelector('#pages-container .slick-carousel');
      if (hasSlick) {
        // setSlick は mounted / updated で走る。init・setPosition 後にレイアウトが安定するまで待つ
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setTimeout(run, PAGES_SLICK_ANCHOR_DELAY_MS);
          });
        });
      } else {
        run();
      }
    });
  }

  /** v-html 反映・Slick 初期化後に要素が乗るまでリトライする */
  private runScrollAfterContentReady(attempt: number) {
    const maxAttempts = 40;
    const intervalMs = 50;

    const q = this.$route.query as Record<string, string | (string | null)[] | null | undefined>;
    const rawScroll = q.scroll;
    const scrollId =
      typeof rawScroll === 'string'
        ? rawScroll
        : Array.isArray(rawScroll) && rawScroll[0]
          ? String(rawScroll[0])
          : '';

    const hashFromRoute = (this.$route.hash || '').replace(/^#/, '');

    const scrollToEl = (el: HTMLElement) => {
      scrollElementIntoViewBelowFixedHeader(el, 'smooth');
    };

    if (scrollId) {
      const anchor = document.getElementById(scrollId);
      if (!anchor) {
        if (attempt < maxAttempts) {
          setTimeout(() => this.runScrollAfterContentReady(attempt + 1), intervalMs);
        }
        return;
      }
      scrollToEl(anchor);
      const nextQuery = { ...q };
      delete nextQuery.scroll;
      const hasQuery = Object.keys(nextQuery).length > 0;
      this.$router
        .replace({
          path: this.$route.path,
          query: hasQuery ? nextQuery : {},
          hash: `#${scrollId}`,
        })
        .catch(() => {});
      return;
    }

    if (hashFromRoute) {
      const anchor = document.getElementById(hashFromRoute);
      if (!anchor) {
        if (attempt < maxAttempts) {
          setTimeout(() => this.runScrollAfterContentReady(attempt + 1), intervalMs);
        }
        return;
      }
      scrollToEl(anchor);
      return;
    }

    const elm = document.getElementById('pages-container');
    if (elm) {
      scrollToEl(elm);
    }
  }

  public mounted() {
    store.commit('loaded', true);
    this.slug = String(this.$route.params.slug);
    const router = this.$router;
    $(document).on('click', '#pages-container a', function(e) {
      const moveTo: any = $(this).attr('href');
      const target: any = $(this).attr('target');
      const test1 = /^http(s)?:\/\//.test(moveTo);
      const test2 = moveTo.indexOf(process.env.VUE_APP_SITE_URL);
      if (!/^#/.test(moveTo) &&(!test1 || test2 === 0) && target !== '_blank') {
        e.preventDefault();
        router.push(String(moveTo));
      }
    });

    this.setSlick();
  }
  private async beforeRouteEnter(to: Route, from: Route, next: any) {
    const result = await store.dispatch('pages/getEntry', {
      slug: to.params.slug,
    })
    .then((response) => {
      // this.slug = String(to.params.slug);
      if (response.datas.length === 0) {
        store.commit('pages/setStatusCode', 404);
        store.dispatch('head/updateTitle', '404 Page not found', {root: true});
      } else {
        store.commit('pages/setStatusCode', 200);
        store.commit('pages/setData', response.datas);
        store.dispatch('head/updateTitle', response.datas[0].title, {root: true});
      }
    })
    // .catch((e) => {
    //   store.commit('pages/setStatusCode', 404);
    //   store.dispatch('head/updateTitle', '404 Page not found', {root: true});
    // })
    .finally(()=> {
      next()
    })
  }
  private async beforeRouteUpdate(to: Route, from: Route, next: any) {
    // query / hash だけの変更（例: ?scroll=guide の replace）では再取得しない
    if (to.params.slug === from.params.slug) {
      next();
      return;
    }
    await store.dispatch('pages/getEntry', {
      slug: to.params.slug,
    })
    .then((response) => {
      this.slug = String(to.params.slug);
      if (response.datas.length === 0) {
        store.commit('pages/setStatusCode', 404);
        store.dispatch('head/updateTitle', '404 Page not found', {root: true});
      } else {
        store.commit('pages/setStatusCode', 200);
        store.commit('pages/setData', response.datas);
        store.dispatch('head/updateTitle', response.datas[0].title, {root: true});
      }      
    })
    // .catch((e) => {
    //   store.commit('pages/setStatusCode', 404);
    //   store.dispatch('head/updateTitle', '404 Page not found', {root: true});
    // })
    .finally(()=>{
      next(); // needs to be called to confirm the navigation
    })
  }
  private updated() {
    // this.slug = String(this.$route.params.slug);
    this.setSlick();
  }
  private destroyed() {
    $(document).off('click', '#pages-container a');
  }
  @Emit()
  private setSlick() {
    const slickElm: any = $('.slick-carousel');
    slickElm.slick({
      responsive: [
        {
          breakpoint: 9999,
          settings: 'unslick'
        },
        {
          breakpoint: 750,
          settings: {
            dots: true,
            infinite: false,
            arrows: false,
            variableWidth: true,
          }
        }
      ]
    });
  }

}
